import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { createVacancy } from "../../services/school/vacancy/vacancy";
import { VacancyType } from "../../types/Vacancy";
import { useForm } from "react-hook-form";
import { CreateVacancyFormValidation } from "./CreateVacancyFormValidation";
import { useGetCoursesQuery } from "../../hooks/useGetCoursesQuery";
import { useGetFacultiesQuery } from "../../hooks/useGetFacultiesQuery";
import { useGetDepartamentsQuery } from "../../hooks/useGetDepartamentsQuery";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { useGetCurrentAcademicYearQuery } from "../../hooks/useGetCurrentAcademicYearQuery";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { useGetUniversitiesQuery } from "../../hooks/useGetUniversitiesQuery";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";

export const CreateVacancy = () => {
  const mutation = useMutation({ mutationFn: createVacancy, mutationKey: 'createVacancy' });
  const navigate = useNavigate();
  const { data: academicYear, isLoading: isLoadingacademicYear } = useGetCurrentAcademicYearQuery();

  const defaultValues: VacancyType = {
    numberOfVacancies: 0,
    idAcademicYear: academicYear?.id ?? "",
    idCourse: "",
    regime:"1",
    idFaculty: "",
    idDepartament: ""
  }
  const { control, handleSubmit, formState: { errors }, getValues, setValue } = useForm<VacancyType>
    (
      {
        resolver: yupResolver(CreateVacancyFormValidation),
        defaultValues: defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
  const { data:universities, isLoading: isLoadingUniversities, isError: errorUniversities, refetch: refetchUniversities } = useGetUniversitiesQuery({ PageNumber: 1, PageSize: 400 });
  const { data: faculties, isLoading: isLoadingFaculties, isError: errorFaculties,refetch:refetchFaculties  } = useGetFacultiesQuery({ PageNumber: 1, PageSize: 400,IdUniversity:getValues('idUniversity') });
  const { data: departaments, isLoading: isLoadingDepartaments, isError: errorDepartaments, refetch: refreshDepartaments } = useGetDepartamentsQuery({ PageNumber: 1, PageSize: 400, IdFaculty: getValues('idFaculty') }, { enabled: !!getValues('idFaculty') });
  const { data: courses, isLoading: isLoadingCourses, isError: errorCourses, refetch: refreshCourses } = useGetCoursesQuery({ PageNumber: 1, PageSize: 400, IdDepartament: getValues('idDepartament') }, { enabled: !!getValues('idDepartament') });

  const onSubmit = handleSubmit(async (data) => {
    try {
      data.idAcademicYear = academicYear?.id;
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Vaga criada!");
        navigate(routes.vacancies);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleFacultyChange = (idFaculty: string) => {
    setValue('idFaculty', idFaculty);
    setValue('idDepartament', '');
    setValue('idCourse', '');
    refreshDepartaments();
  };
  const handleDepartamentChange = (idDepartament: string) => {
    setValue('idDepartament', idDepartament);
    setValue('idCourse', '');
    refreshCourses();
  };
  const handleBack = () => {
    navigate(routes.vacancies);
  }
  const handleUniversityChange = (id: string) => {
    setValue('idUniversity', id);
    setValue('idFaculty', '');
    setValue('idDepartament', '');
    setValue('idCourse', '');
    refetchFaculties();
  };
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="numberOfVacancies" label='Vagas' control={control} errors={errors} fieldProps={{ placeholder: 'Vagas', type: 'number' }} required={true}/>
            <RadioGroupComponent name="regime" label="Regime" control={control} errors={errors} style={{ width: '100%' }}
              options={[
                { value: "1", label: "Laboral" }
                , { value: "2", label: "Pós Laboral" }
                , { value: "3", label: "Distância" }
              ]}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: '16px' }
              }}
            />
          
          <SelectComponent
            name="idUniversity"
            label="Instituição de Ensino Superior"
            control={control}
            errors={errors}
            style={{ width: '100%' }}
            options={universities?.items.map(u => ({
              value: u.id ?? "",
              label: u.description ?? ""
            }))}
            itemsLoading={isLoadingUniversities}
            itemsError={errorUniversities}
            onSelect={handleUniversityChange}
            required={true}
          />
          <SelectComponent itemsError={errorFaculties} itemsLoading={isLoadingFaculties} name="idFaculty" label='Unidade orgânica' control={control} errors={errors} style={{ width: '100%' }}
            options={faculties?.items.map(faculty => ({
              value: faculty.id ?? "",
              label: faculty.description ?? ""
            }))}
            onSelect={handleFacultyChange}
            required={true}
          />
          <SelectComponent itemsError={errorDepartaments} itemsLoading={isLoadingDepartaments} name="idDepartament" label='Departamento' control={control} errors={errors} style={{ width: '100%' }}
            options={departaments?.items.map(d => ({
              value: d.id ?? "",
              label: d.description ?? ""
            }))}
            onSelect={handleDepartamentChange}
            required={true}
          />
          <SelectComponent itemsError={errorCourses} itemsLoading={isLoadingCourses} name="idCourse" label='Curso' control={control} errors={errors} style={{ width: '100%' }}
            options={courses?.items.map(d => ({
              value: d.id ?? "",
              label: d.description ?? ""
            }))}
            required={true}
          />

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>

      </Card>

    </form>
  )
}
